import { useEffect, useState } from 'react';
import logo from '@/assets/logo.png';

const TOTAL_DURATION_MS = 3500;

export default function WelcomeAnimation() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), TOTAL_DURATION_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <>
      <style>{`
        @keyframes luxkgateWelcomeFlyIn {
          0%   { transform: translateZ(0) scale(0.6); opacity: 0; }
          15%  { transform: translateZ(0) scale(1);   opacity: 1; }
          100% { transform: translateZ(0) scale(9);   opacity: 0; }
        }
        @keyframes luxkgateWelcomeOverlayOut {
          0%, 70% { opacity: 1; }
          100%    { opacity: 0; visibility: hidden; }
        }
        .luxkgate-welcome-overlay {
          animation: luxkgateWelcomeOverlayOut ${TOTAL_DURATION_MS}ms linear forwards;
          will-change: opacity;
        }
        .luxkgate-welcome-logo {
          transform-origin: center center;
          animation: luxkgateWelcomeFlyIn ${TOTAL_DURATION_MS}ms cubic-bezier(0.5, 0, 0.75, 0) forwards;
          will-change: transform, opacity;
          backface-visibility: hidden;
        }
      `}</style>
      <div className="luxkgate-welcome-overlay fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950 overflow-hidden">
        <div className="luxkgate-welcome-logo flex items-center gap-2">
          <img src={logo} alt="Luxkgate" className="h-20 w-auto object-contain" draggable={false} />
          <span className="font-bold text-4xl tracking-tight text-white">Luxkgate</span>
        </div>
      </div>
    </>
  );
}
